import { render, staticRenderFns } from "./PelatihanList.vue?vue&type=template&id=54107374"
import script from "./PelatihanList.vue?vue&type=script&lang=js"
export * from "./PelatihanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports